import {
  IBaseResponseApi,
  IfilteApi,
} from "../../Interfaces/gestionDocumentos/ITipoDocumento";
import { fetchAdministracion, fetchGestionDocumentos } from "../http-common";

const crearGrupoDocumento = (body: any) => {
  return fetchGestionDocumentos.post<IBaseResponseApi>(`Archivo/Crear`, body);
};

const editarGrupoDocumento = (body: any) => {
  return fetchGestionDocumentos.put<IBaseResponseApi>(`Archivo/Editar`, body);
};

//   const actualizarTipoDocumento = (body: any) => {
//     return fetchGestionDocumentos.post<IBaseResponseApi>(
//       `TipoDocumentos/Editar`,
//       body
//     );
//   };

const deleteArchivo = (archivoId: string) => {
  return fetchGestionDocumentos.put<IBaseResponseApi>(
    `Archivo/Eliminar?ArchivoId=${archivoId}`
  );
};

const deleteDocumentosMasivo = (archivosId: string[]) => {
  return fetchGestionDocumentos.put<IBaseResponseApi>(
    `Archivo/EliminarDocumentos`,
    archivosId
  );
};

const listarGrupos = (
  filter: IfilteApi,
  controller = new AbortController()
) => {
  return fetchGestionDocumentos.get(`Archivo/Tabla`, {
    params: filter,
    signal: controller.signal,
  });
};

const getCountFiles = (archivoId: string) => {
  return fetchGestionDocumentos.get(`Archivo/ById?ArchivoId=${archivoId}`);
};

const getBase64 = (body: any) => {
  return fetchGestionDocumentos.post(`Archivo/ArchivoBase64`, body);
};

const postDownloadZip = (body: string[]) => {
  return fetchGestionDocumentos.post(`Archivo/DownloadZip`, body);
};

const getHistorial = (archivoId: string) => {
  return fetchGestionDocumentos.get(
    `HistorialDocumentos/ByArchivoId?ArchivoId=${archivoId}`
  );
};

const grupoDocumentoService = {
  listarGrupos,
  getCountFiles,
  crearGrupoDocumento,
  deleteArchivo,
  getBase64,
  editarGrupoDocumento,
  getHistorial,
  deleteDocumentosMasivo,
  postDownloadZip,
};

export default grupoDocumentoService;
